<template>
	<div class="post-smtp__wrapper">

		<post-smtp-header></post-smtp-header>

		<div class="mt-32 clearfix container">

			<div class="app-wrapper float-left mr-25">
				<post-smtp-dashboard
					:post-smtp-configured="postSmtpConfigured"
					:post-smtp-pro="postSmtpPro"
					:post-smtp-ad-position="adPosition"
          :is-log-only-mode="isLogOnlyMode"
				></post-smtp-dashboard>
			</div>
			<div class="app-sidebar float-left">
				<post-smtp-sidebar
					:post-smtp-configured="postSmtpConfigured"
					:post-smtp-pro="postSmtpPro"
					:is-mobile-app-configured="isMobileAppConfigured"
					:is-main-wp-configured="isMainWpConfigured"
					:is-domain-spam-score-configured="isDomainSpamScoreConfigured"
				></post-smtp-sidebar>
			</div>
			
		</div>

	</div>
</template>

<script>
export default {
	name: 'PostSMTPAppWrapper',

	props: {
		postSmtpConfigured         : {
			type: Boolean,
			default: false,
		},
		postSmtpPro                : {
			type: Boolean,
			default: false,
		},
		isMobileAppConfigured      : {
			type: Boolean,
			default: false,
		},
		isMainWpConfigured         : {
			type: Boolean,
			default: false,
		},
		isDomainSpamScoreConfigured: {
			type: Boolean,
			default: false,
		},

		adPosition: {
			type: String,
			default: 'maximize',
		},

    isLogOnlyMode: {
      type: Boolean,
      default: false,
    }
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,
	} ),
}
</script>

<style scoped>
.post-smtp__wrapper {
	background: #F9FBFF;
}

.mr-25 {
	margin-right: 25px;
}

.container {
	padding: 0 51px;
}

.mt-32 {
	margin-top: 32px;
}

.app-wrapper {
	width: calc( 100% - 276px - 25px );
}

.app-sidebar {
	width: 276px;
}

.float-left {
	float: left;
}

.clearfix::after {
	clear: both;
	content: "";
	display: table;
}
</style>